import { render, staticRenderFns } from "./MentorReport.vue?vue&type=template&id=35cc1cc6&scoped=true"
import script from "./MentorReport.vue?vue&type=script&lang=ts"
export * from "./MentorReport.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35cc1cc6",
  null
  
)

export default component.exports